import matchCurrentVolume from "../chronology/current/match-current-volume";
import getRecentVolume from "../chronology/recent/get-recent-volume";
import getFutureVolume from "../chronology/future/get-future-volume";

export default function autoVolume({ state, getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  // Once the container is loaded, there might be a volume
  // defined, which the current date falls into.
  // If that is so, return that current volume.
  return (
    matchCurrentVolume({ state, getters }) ||
    // Do we have a previous volume?
    getRecentVolume({ state, getters }) ||
    // No previous volume in the dataset. Do we have a next volume?
    getFutureVolume({ state, getters })
  ); // Implicit ... || null.
}
